import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { I18nextPhraseBackend } from '@phrase/i18next-backend';
import { Locale } from '@org-avp/avp-hck-dga-customerui-commons';

import en from './locales/vw/en/translations.json';
import { getOtaBackendOptions, isOtaConfigured } from './phraseOta';
import { supportedLocales } from './supportedLocales';

export { supportedLocales };

export const resources = {
  en: {
    translation: en,
  },
};

let initPromise: Promise<unknown> | undefined;

export const waitForI18nInit = async (): Promise<void> => {
  if (initPromise) {
    await initPromise;
  }
};

export const toInitialLanguage = (locale: string): Locale => {
  if (supportedLocales.includes(locale)) {
    return locale as Locale;
  }
  const baseLang = locale.slice(0, 2);

  const initialLanguage = supportedLocales.find((key) => key.startsWith(baseLang));
  return initialLanguage ? (initialLanguage as Locale) : Locale.en;
};

export const getBrowserLocale = (): Locale => {
  const raw = typeof navigator === 'undefined' ? 'en' : navigator.language;
  return toInitialLanguage(raw.replace('_', '-'));
};

export const initI18n = (lng: string): void => {
  i18n.use(initReactI18next);

  if (isOtaConfigured()) {
    i18n.use(I18nextPhraseBackend);
  }

  initPromise = i18n.init({
    lng: lng || 'en',
    debug: true,
    fallbackLng: 'en',
    load: 'currentOnly',
    react: { useSuspense: false },
    partialBundledLanguages: true,
    resources,
    ...(isOtaConfigured() ? { backend: getOtaBackendOptions() } : {}),
  });
};
